export default "__VITE_ASSET__XgQMh3iM__"